const BoltIcon = () => (
  <svg className="w-3.5 h-3.5" fill="#4ade80" viewBox="0 0 24 24">
    <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13L13 2Z" />
  </svg>
);

const LinkIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
  </svg>
);

const projects = [
  {
    id: 1,
    image: "/images/project-photon.jpg",
    title: "Photon Fusion",
    category: "Geothermal Energy",
    link: "#",
  },
  {
    id: 2,
    image: "/images/project-luxsolar.jpg",
    title: "LuxSolar Dynamics",
    category: "Geothermal Energy",
    link: "#",
  },
  {
    id: 3,
    image: "/images/project-solarburst.jpg",
    title: "Solarburst Ventures",
    category: "Solar Power",
    link: "#",
  },
  {
    id: 4,
    image: "/images/project-sunworks.jpg",
    title: "Sunworks Initiative",
    category: "Geothermal Energy",
    link: "#",
  },
];

export default function LatestProjects() {
  return (
    <div
      className="w-full py-16 px-6 md:px-10 lg:px-12 xl:px-20"
      style={{ background: "#eef2ec", fontFamily: "'Barlow', 'Montserrat', sans-serif" }}
    >
      <div className="">

        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-1.5 mb-3">
            <BoltIcon />
            <span className="text-sm font-rajdhani font-bold tracking-[0.2em] uppercase" style={{ color: "#4ade80" }}>
              LATEST PROJECT
            </span>
          </div>
          <h2
            className="font-bold text-[#1a2e0a] font-rajdhani text-2xl md:text-4xl lg:text-[45px] leading-relaxed "
            style={{ letterSpacing: "-0.02em" }}
          >
            Our Latest Projects
          </h2>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {projects.map(({ id, image, title, category, link }) => (
            <div
              key={id}
              className="group relative rounded-3xl overflow-hidden cursor-pointer"
              style={{
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                background: "#dde8d8",
              }}
            >
              {/* Image */}
              <div className="relative overflow-hidden" style={{ height: "340px" }}>
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />

              </div>

              {/* White info footer */}
              <div
                className="absolute bottom-0 left-0 right-0 px-5 py-4 rounded-b-3xl"
                style={{ background: "rgba(255,255,255,0.96)" }}
              >
                <h3 className="font-extrabold font-rajdhani text-gray-900 tracking-wide text-lg leading-relaxed mb-0.5">
                  {title}
                </h3>
                <p className="text-gray-400 text-sm">{category}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}